<template>
    <div>
        <h5>Оплаты по позициям (структура ТМЦ заблокирована)</h5>
        <div v-for="(line, i) in lines" :key="line.id" class="border rounded p-3 mb-3">
            <strong>Позиция {{ i + 1 }} · складская стоимость: {{ line.cost_state === 'unknown' ? 'неизвестна' : line.cost_state === 'zero' ? '0 ₽' : line.line_cost + ' ₽' }}</strong>
            <input type="hidden" :name="'lines[' + i + '][id]'" :value="line.id">
            <input type="hidden" :name="'lines[' + i + '][payments_submitted]'" value="1">
            <input type="hidden" :name="'lines[' + i + '][payment_snapshot]'" :value="line.payment_snapshot">
            <p>Сумма фактических оплат: {{ money(paid(line)) }} ₽ · признанная стоимость: {{ line.recognition_action === 'recognize_now' ? line.line_cost + ' ₽' : line.recognition_action === 'already_recognized' ? 'учтена ранее' : 'не признана сейчас' }} · ещё не учтённая стоимость: {{ undistributedCost(line) }}</p>
            <div v-for="(payment, j) in line.payments" :key="payment.payment_key" class="row align-items-end">
                <input v-if="payment.id" type="hidden" :name="'lines[' + i + '][payments][' + j + '][id]'" :value="payment.id">
                <input type="hidden" :name="'lines[' + i + '][payments][' + j + '][payment_key]'" :value="payment.payment_key">
                <div class="col-12 col-md-3 form-group"><label :for="'locked-payment-amount-' + i + '-' + j">Сумма, руб.</label><input :id="'locked-payment-amount-' + i + '-' + j" class="form-control" :name="'lines[' + i + '][payments][' + j + '][amount]'" v-model="payment.amount" required @input="clearReview(line)"></div>
                <div class="col-12 col-md-3 form-group"><label :for="'locked-payment-date-' + i + '-' + j">Дата оплаты</label><input :id="'locked-payment-date-' + i + '-' + j" type="text" class="form-control js-locked-payment-date" data-date-picker-enabled="true" data-date-picker-format="dd.mm.yyyy" data-date-format="dd.mm.yyyy" autocomplete="off" placeholder="ДД.ММ.ГГГГ" :data-payment-key="payment.payment_key" :name="'lines[' + i + '][payments][' + j + '][date]'" v-model="payment.date" required></div>
                <div class="col-12 col-md-4 form-group"><label>Объект ДДС</label><property-picker :name="'lines[' + i + '][payments][' + j + '][property_id]'" v-model="payment.property_id" :options="properties" picker-type="cash" placeholder="Выберите объект ДДС"></property-picker></div>
                <div class="col-12 col-md-2 form-group"><button class="btn btn-outline-danger" type="button" @click="remove(line, j)">Удалить</button></div>
            </div>
            <p v-if="line.cost_state === 'unknown' && paid(line) > 0" class="alert alert-info">Стоимость неизвестна; сравнение пока невозможно.</p>
            <template v-if="paid(line) > 0 && line.cost_state !== 'unknown'">
                <p v-if="difference(line)" class="alert alert-warning">Разница оплаты и стоимости: {{ difference(line) > 0 ? '+' : '−' }}{{ money(Math.abs(difference(line))) }} ₽</p>
                <label v-if="difference(line)" class="d-block"><input type="checkbox" :name="'lines[' + i + '][confirmed_difference_kopecks]'" :value="difference(line)" :checked="line.reviewed_difference_kopecks === difference(line)" @change="line.reviewed_difference_kopecks = $event.target.checked ? difference(line) : null"> Подтверждаю разницу оплаты и стоимости</label>
                <label v-if="line.cost_state === 'zero'" class="d-block"><input type="checkbox" :name="'lines[' + i + '][confirm_zero_payment]'" value="1" :checked="line.reviewed_zero_payment_kopecks === paid(line)" @change="line.reviewed_zero_payment_kopecks = $event.target.checked ? paid(line) : null"> Подтверждаю оплату при нулевой стоимости</label>
            </template>
            <button type="button" class="btn btn-sm btn-outline-primary" @click="add(line)">Добавить оплату</button>
        </div>
        <div class="card bg-light mb-3">
            <div class="card-body py-2">
                <div class="row text-center">
                    <div class="col-md-3"><strong>Складская стоимость:</strong> {{ documentCost }}</div>
                    <div class="col-md-3"><strong>Фактические оплаты:</strong> {{ money(totalPaid) }} ₽</div>
                    <div class="col-md-3"><strong>Признанная стоимость:</strong> {{ money(totalRecognized) }} ₽</div>
                    <div class="col-md-3"><strong>Ещё не учтённая стоимость:</strong> {{ documentUndistributed }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PropertyPicker from './property-picker.vue';
export default {
    components: {PropertyPicker},
    props: {initialLines: Array, properties: Array},
    data() {
        return {lines: this.initialLines.map(line => Object.assign({}, line, {
            reviewed_difference_kopecks: Number(line.confirmed_difference_kopecks) || null,
            reviewed_zero_payment_kopecks: line.confirm_zero_payment ? Object.values(line.payments || {}).reduce((sum, payment) => sum + this.kopecks(payment.amount), 0) : null,
            payments: (Array.isArray(line.payments) ? line.payments : Object.values(line.payments || {})).map(payment => Object.assign({}, payment, {
                date: this.formatDate(payment.date) || this.todayFormatted()
            })),
        }))};
    },
    mounted() {
        this.refreshDynamicControls();
    },
    updated() {
        this.refreshDynamicControls();
    },
    computed: {
        totalPaid() {
            return this.lines.reduce((sum, line) => sum + this.paid(line), 0);
        },
        totalStock() {
            return this.lines.reduce((sum, line) => sum + (line.cost_state === 'specified' ? this.kopecks(line.line_cost) : 0), 0);
        },
        hasUnknown() {
            return this.lines.some(line => line.cost_state === 'unknown');
        },
        documentCost() {
            if (this.lines.length > 0 && this.lines.every(line => line.cost_state === 'unknown')) {
                return 'Неизвестна';
            }
            return this.hasUnknown ? this.money(this.totalStock) + ' ₽ (не все оценены)' : this.money(this.totalStock) + ' ₽';
        },
        totalRecognized() {
            return this.lines.reduce((sum, line) => {
                if (line.cost_state === 'specified' && (line.recognition_action === 'recognize_now' || line.recognition_action === 'already_recognized')) {
                    return sum + this.kopecks(line.line_cost);
                }
                return sum;
            }, 0);
        },
        documentUndistributed() {
            if (this.lines.length > 0 && this.lines.every(line => line.cost_state === 'unknown')) {
                return 'Неизвестна';
            }
            const undistributed = Math.max(0, this.totalStock - this.totalRecognized);
            return this.hasUnknown ? this.money(undistributed) + ' ₽ (не все оценены)' : this.money(undistributed) + ' ₽';
        }
    },
    methods: {
        kopecks(value) { const normalized = String(value || '').replace(/\s/g, '').replace(',', '.'); return /^\d+(\.\d{1,2})?$/.test(normalized) ? Math.round(Number(normalized) * 100) : 0; },
        money(value) { return (value / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2}); },
        paid(line) { return line.payments.reduce((sum, payment) => sum + this.kopecks(payment.amount), 0); },
        difference(line) { return this.paid(line) - (line.cost_state === 'specified' ? this.kopecks(line.line_cost) : 0); },
        undistributedCost(line) {
            if (line.cost_state === 'unknown') {
                return 'Неизвестна';
            }
            if (line.cost_state === 'zero') {
                return '0,00 ₽';
            }
            const lineCost = this.kopecks(line.line_cost);
            const recognized = line.recognition_action === 'recognize_now' || line.recognition_action === 'already_recognized' ? lineCost : 0;
            return this.money(Math.max(0, lineCost - recognized)) + ' ₽';
        },
        clearReview(line) { line.reviewed_difference_kopecks = null; line.reviewed_zero_payment_kopecks = null; },
        formatDate(value) {
            if (!value) {
                return '';
            }
            if (window.formatDateForDisplay) {
                return window.formatDateForDisplay(value);
            }
            const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (match) {
                return `${match[3]}.${match[2]}.${match[1]}`;
            }

            return value;
        },
        todayFormatted() {
            const today = new Date();
            return `${String(today.getDate()).padStart(2, '0')}.${String(today.getMonth() + 1).padStart(2, '0')}.${today.getFullYear()}`;
        },
        refreshDynamicControls() {
            this.$nextTick(() => {
                if (!window.$ || !window.initDynamicFormControls) {
                    return;
                }
                window.initDynamicFormControls(this.$el);
                window.$(this.$el).find('.js-locked-payment-date').off('changeDate.locked change.locked input.locked').on('changeDate.locked change.locked input.locked', event => {
                    const input = window.$(event.currentTarget);
                    const paymentKey = String(input.data('payment-key') || '');
                    for (const line of this.lines) {
                        const payment = (line.payments || []).find(p => String(p.payment_key) === paymentKey);
                        if (payment) {
                            payment.date = input.val();
                            break;
                        }
                    }
                });
            });
        },
        remove(line, index) {
            if (!window.confirm('Удалить ошибочную оплату поставщику?')) {
                return;
            }
            line.payments.splice(index, 1);
            this.clearReview(line);
        },
        add(line) {
            const key = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
                const value = Math.random() * 16 | 0;
                return (char === 'x' ? value : (value & 3 | 8)).toString(16);
            });
            const date = this.todayFormatted();
            line.payments.push({payment_key: key, amount: '', date, property_id: ''});
            this.clearReview(line);
            this.$nextTick(() => {
                this.refreshDynamicControls();
            });
        }
    }
};
</script>
